import { getConfigsMFEFirebase } from '../../../helpers/mfeConfisFirebase'
import { CompanyId } from '../../../models/company-id'
import { CountryId } from '../../../models/country-id'
import { getDefault } from './defaultConfigs'

export const getNaturaMalaysia = () => ({
  ...getDefault(),
  country: {
    alpha2Code: CountryId.MALAYSIA,
    alpha3Code: 'MYS',
    language: 'en',
  },
  company: {
    name: 'NATURA',
    id: CompanyId.NATURA,
    logout: {
      buttonLinkHref: '/login?country=MYS&company=NATURA',
      externalLink: false,
    },
  },
  showEditButtonDetails: true,
  redirectUrlToLogin: {
    url: async () => getConfigsMFEFirebase('HOSTED_UI_AUTHENTICATION_URL'),
    clientId: async () => getConfigsMFEFirebase('CLIENT_ID_COGNITO'),
  },
})
